export * from './onboarding-beneficios.component';
